import { Grid, Step, StepLabel, Stepper } from "@material-ui/core";
import { CSSProperties, ReactElement, useState } from "react";
import { isNullOrUndefined } from "../../utils/CommonFunctions";
import RxButton from "../RxButton";
import RxPaper from "../RxPaper";
import RxTypography from "../RxTypography";
import styles from "./RxStepForm.module.css";

interface RxStepFormChild {
	title: string;
	content: ReactElement;
	valid: boolean;
	nextButtonId?: string;
	nextButtonHide?: boolean;
	nextButtonName?: string;
	nextButtonColor?: "inherit" | "default" | "primary" | "secondary";
	nextButtonSize?: "small" | "medium" | "large";
	nextButtonOnClick?: () => void;
	backButtonHide?: boolean;
	backButtonName?: string;
	backButtonColor?: "inherit" | "default" | "primary" | "secondary";
	backButtonSize?: "small" | "medium" | "large";
	backButtonOnClick?: () => void;
}

export interface DescriptionObject {
	isBold?: boolean;
	value: string;
}

interface RxStepFormProps {
	title: string;
	description?: DescriptionObject[];
	width?: string;
	minWidth?: string;
	direction?: "horizontal" | "vertical";
	steps: RxStepFormChild[];
	className?: string;
}

const RxStepForm = (props: RxStepFormProps) => {
	const [currentStep, setCurrentStep] = useState(0);

	let outPaperStyle: CSSProperties = {
		alignItems: "center",
		alignContent: "center",
		textAlign: "center",
	};
	if (!isNullOrUndefined(props.width)) {
		outPaperStyle = {
			...outPaperStyle,
			width: props?.width,
			margin: "auto",
			marginTop: "20px",
		} as CSSProperties;
	}
	if (!isNullOrUndefined(props.minWidth)) {
		outPaperStyle = {
			...outPaperStyle,
			minWidth: props?.minWidth,
		} as CSSProperties;
	}

	return (
		<RxPaper className={props.className} style={outPaperStyle}>
			<Grid container direction="row" spacing={5}>
				<Grid
					container
					direction="row"
					spacing={5}
					className={styles.marginBottomFive}
				>
					<Grid item xs={12} sm={12}>
						<RxTypography
							variant="h4"
							align="center"
							label={props.title}
						/>
					</Grid>
				</Grid>
				{props.description && (
					<Grid container direction="row" spacing={5}>
						<Grid item xs={12} sm={12}>
							{props.description.map((item, index) => {
								if (item.isBold) {
									return (
										<RxTypography
											key={index}
											variant="subtitle2"
											align="center"
											label={item.value}
											component="span"
											className={styles.boldFont}
										/>
									);
								} else {
									return (
										<RxTypography
											key={index}
											variant="subtitle2"
											align="center"
											label={item.value}
											component="span"
										/>
									);
								}
							})}
						</Grid>
					</Grid>
				)}
				<Grid container direction="row" spacing={5}>
					<Grid item xs={12} sm={12}>
						<Stepper
							activeStep={currentStep}
							orientation={props.direction}
							alternativeLabel={
								isNullOrUndefined(props.direction) ||
								props.direction === "horizontal"
							}
							className={styles.marginVerticalTwenty}
						>
							{props.steps.map((step) => (
								<Step key={step.title}>
									<StepLabel>{step.title}</StepLabel>
								</Step>
							))}
						</Stepper>
					</Grid>
				</Grid>
				<Grid container direction="row" spacing={5}>
					<Grid item xs={12} sm={12}>
						{props.steps[currentStep].content}
					</Grid>
				</Grid>
				<Grid
					container
					direction="row"
					spacing={2}
					className={styles.marginTopTwenty}
				>
					<Grid item xs={4} sm={8}></Grid>
					<Grid item xs={4} sm={2}>
						{!props.steps[currentStep].backButtonHide &&
							currentStep !== 0 && (
								<RxButton
									fullWidth
									color={
										props.steps[currentStep].backButtonColor ??
										"primary"
									}
									size={props.steps[currentStep].backButtonSize}
									variant="contained"
									label={
										props.steps[currentStep].backButtonName ?? "GERİ"
									}
									onClick={() => {
										if (
											!isNullOrUndefined(
												props.steps[currentStep].backButtonOnClick
											)
										) {
											const tmpStep = props?.steps[currentStep];
											tmpStep?.backButtonOnClick &&
												tmpStep?.backButtonOnClick();
										} else {
											setCurrentStep((prev) => {
												return prev - 1;
											});
										}
									}}
								/>
							)}
					</Grid>
					<Grid item xs={4} sm={2}>
						{!props.steps[currentStep].nextButtonHide && (
							<RxButton
								id={props.steps[currentStep].nextButtonId}
								fullWidth
								color={
									props.steps[currentStep].nextButtonColor ?? "primary"
								}
								size={props.steps[currentStep].nextButtonSize}
								variant="contained"
								disabled={!props.steps[currentStep].valid}
								label={
									props.steps[currentStep].nextButtonName ??
									(currentStep !== props.steps.length
										? "İLERİ"
										: "Tamamla")
								}
								onClick={() => {
									if (props.steps[currentStep].valid) {
										if (
											!isNullOrUndefined(
												props.steps[currentStep].nextButtonOnClick
											)
										) {
											const tmpStep = props?.steps[currentStep];
											tmpStep?.nextButtonOnClick &&
												tmpStep?.nextButtonOnClick();
										} else {
											setCurrentStep((prev) => {
												return prev + 1;
											});
										}
									}
								}}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
		</RxPaper>
	);
};

export default RxStepForm;
